module.exports = __webpack_public_path__ + "static/media/icon_124.9592bbb0.svg";